import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b11d2a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-title" }
const _hoisted_2 = { class: "flex justify-end" }

import StockCodeList from "@/components/product/code/StockCodeList.vue"
import StockCodeAvailableList from "@/components/product/code/StockCodeAvailableList.vue"
import StockCodeNotAvailableList from "@/components/product/code/StockCodeNotAvailableList.vue"
import AdminPageLayout from '@/layouts/default/admin/AdminPageLayout.vue';
import DataNavList from '@/components/utility/DataNavList.vue';
import { ListingTabs } from '@/models/utility/ListingTabs';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListCodes',
  setup(__props) {

const codeListingTabs: ListingTabs = {
    available: {
        label: "Disponibles",
        component: StockCodeAvailableList
    },
    notAvailable: {
        label: "Non disponibles",
        component: StockCodeNotAvailableList
    },
    stock: {
        label: "Stock de codes",
        component: StockCodeList
    },
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t("catalogue.codes.title")), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "importLink",
        to: "/admin/catalogue/code/create"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Importer des codes")
        ]),
        _: 1
      })
    ]),
    _createVNode(DataNavList, { tabs: codeListingTabs })
  ], 64))
}
}

})